import { Typography } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, getColumnValue, numberColumn, textColumn, textareaColumn, yesNoColumn } from "./columnHelpers";

export const improvementsRelationship = {
    collapsible: true,
    title: 'Improvements',
    tint: 'default',
    type: 'table',
    sort: ['date', 'desc'],
    columns: [
        textareaColumn({label: 'Improvement', column: 'description'}),
        dateColumn({width: '25%'}),
        currencyColumn({width: '25%'}),
    ],
};
